/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Type_CompanyInputs */

const en_clients_type_company = /** @type {(inputs: Clients_Type_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const pt_br2_clients_type_company = /** @type {(inputs: Clients_Type_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pessoa Juridica`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Clients_Type_CompanyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_type_company = /** @type {((inputs?: Clients_Type_CompanyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Type_CompanyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_type_company(inputs)
	return pt_br2_clients_type_company(inputs)
});